export default "__VITE_ASSET__ntO6S5dQ__"